var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetapixel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 485.625 123.76",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mainLogo"
  }, "PetaPixel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mainLogo"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 480.851,
    y1: 87.606,
    x2: 477.395,
    y2: 16.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0265dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3885e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 432.057,
    y1: 89.986,
    x2: 428.601,
    y2: 19.137,
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 365.81,
    y1: 93.217,
    x2: 362.354,
    y2: 22.368,
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 322.292,
    y1: 95.18,
    x2: 318.813,
    y2: 23.875,
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 280.081,
    y1: 97.399,
    x2: 276.625,
    y2: 26.55,
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 198.826,
    y1: 88.884,
    x2: 218.026,
    y2: -14.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 142.554,
    y1: 78.386,
    x2: 161.754,
    y2: -24.528,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 102.414,
    y1: 70.897,
    x2: 121.615,
    y2: -32.016,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 26.73,
    y1: 56.777,
    x2: 45.93,
    y2: -46.137,
    xlinkHref: "#F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.831,119.993H473.275V2h12.556Z",
    fill: "url(#A)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M466.843 103.5a46.387 46.387 0 0 1-15.43 13.312 40.251 40.251 0 0 1-19.211 4.842 38.623 38.623 0 0 1-18.456-4.69 34.608 34.608 0 0 1-12.4-13.766 40.667 40.667 0 0 1-4.236-18.455 39.87 39.87 0 0 1 7.79-24.124q7.789-10.665 16.035-11.951a88.889 88.889 0 0 1 11.27-1.286 38.479 38.479 0 0 1 18.076 4.387 26.66 26.66 0 0 1 12.329 13.388 52.362 52.362 0 0 1 3.934 21.1h-56.882a25.959 25.959 0 0 0 6.486 17.7 20.742 20.742 0 0 0 16.3 7.413 22.343 22.343 0 0 0 5.429-.6 21.933 21.933 0 0 0 10.412-4.312 45.958 45.958 0 0 0 8.6-9.152zm-12.556-26.317a23.509 23.509 0 0 0-8.017-13.841 22.475 22.475 0 0 0-14.976-5.371 18.808 18.808 0 0 0-13.539 5.673 27.019 27.019 0 0 0-7.64 13.539z",
    fill: "url(#B)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.908 49.651l-27.87 34.642 27.53 35.7-15.985.077-18.472-26.923-18.69 26.924-15.529-.078L358.275 85.2l-27.383-35.549 15.917.09 18.5 27 19.018-27.061z",
    fill: "url(#C)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.064,119.993H315.509V49.651h12.555Z",
    fill: "url(#D)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M311.333 35.817v3.924a29.062 29.062 0 0 1-7.542 20.145q-7.542 8.374-19.758 9.582h-23.377v50.525h-13.765V8.051l36.305.454a34.94 34.94 0 0 1 20.044 8.677 24.017 24.017 0 0 1 8.093 18.635zM286.222 21.81a42.2 42.2 0 0 0-7.413-1.81h-18.153v38.274H283.2a18.641 18.641 0 0 0 10.287-7.457 20.963 20.963 0 0 0 3.782-12.131 19.192 19.192 0 0 0-2.723-10.095 16.583 16.583 0 0 0-8.324-6.781z",
    fill: "url(#E)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.727,119.585H222.212V105.46a27.346,27.346,0,0,1-11.669,11.858,33.911,33.911,0,0,1-16.429,4.263,36.759,36.759,0,0,1-8.291-.924q-3.995-.924-10.133-4.769t-10.978-12.924a40.762,40.762,0,0,1-1.171-36.155A57.293,57.293,0,0,1,172.022,55.2q5.88-6.539,17.033-8.54a25.431,25.431,0,0,0,2.675-.154q1.449-.151,2.214-.153a32.421,32.421,0,0,1,15.661,3.838A33.435,33.435,0,0,1,221.6,61.394V48.19h12.13ZM219.3,96.933a33.6,33.6,0,0,0,2.3-12.355,29.97,29.97,0,0,0-3.98-15.442A23.7,23.7,0,0,0,205.68,59.1a29.692,29.692,0,0,0-6.737-.926q-3.98-.154-4.589-.156a23.447,23.447,0,0,0-15.766,9.654A29.407,29.407,0,0,0,172.619,85.5a26.987,26.987,0,0,0,2.219,11.043,27,27,0,0,0,8.035,9.731,22.122,22.122,0,0,0,14.389,4.709A23.682,23.682,0,0,0,219.3,96.933Z",
    fill: "url(#F)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.293,58.938H152.549v60.647H140.113V58.938H128.905V49.111h11.208V20.4h12.436V49.111h12.744Z",
    fill: "url(#G)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.933,103.233a47.108,47.108,0,0,1-15.66,13.512,40.871,40.871,0,0,1-19.5,4.913,39.2,39.2,0,0,1-18.731-4.76,35.119,35.119,0,0,1-12.59-13.972,41.282,41.282,0,0,1-4.3-18.732A40.47,40.47,0,0,1,71.06,59.705q7.905-10.824,16.275-12.129a90.18,90.18,0,0,1,11.438-1.3,39.057,39.057,0,0,1,18.348,4.452,27.059,27.059,0,0,1,12.513,13.588,53.152,53.152,0,0,1,3.992,21.418H75.9a26.36,26.36,0,0,0,6.583,17.965,21.055,21.055,0,0,0,16.541,7.523,22.686,22.686,0,0,0,5.511-.614,22.287,22.287,0,0,0,10.568-4.376,46.67,46.67,0,0,0,8.727-9.289ZM121.19,76.517a23.869,23.869,0,0,0-8.138-14.049,22.816,22.816,0,0,0-15.2-5.45A19.09,19.09,0,0,0,84.11,62.776a27.423,27.423,0,0,0-7.753,13.741Z",
    fill: "url(#H)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.613 34.149v3.982a29.5 29.5 0 0 1-7.655 20.447Q50.3 67.077 37.9 68.3H14.178v51.282H.206V5.968l36.849.46A35.452 35.452 0 0 1 57.4 15.235a24.377 24.377 0 0 1 8.213 18.914zM40.126 19.932A42.644 42.644 0 0 0 32.6 18.1H14.178v38.842h22.877A18.924 18.924 0 0 0 47.5 49.373a21.269 21.269 0 0 0 3.839-12.312 19.483 19.483 0 0 0-2.769-10.247 16.83 16.83 0 0 0-8.444-6.882z",
    fill: "url(#I)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetapixel);
export default __webpack_public_path__ + "static/media/petapixel.5ada540bfef56c65815d973432a2cca6.svg";
export { ForwardRef as ReactComponent };